'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildScheduledMessage = undefined;

var _PubNubMessageStatusTypes = require('../../constants/PubNubMessageStatusTypes');

var _buildMessageWithStatus = require('./buildMessageWithStatus');

var buildScheduledMessage = exports.buildScheduledMessage = (0, _buildMessageWithStatus.buildMessageWithStatus)(_PubNubMessageStatusTypes.SCHEDULED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/factories/PubNubMessageFactory/buildScheduledMessage.js
// module id = 227
// module chunks = 2 3